import {ShowcaseConfig, ServiceCategory} from 'src/app/views/showcase/configs/showcase-config.interface';

export const SHOWCASE_CONFIG: ShowcaseConfig = {
  countryCode: 'COM',
  countryName: 'SHOWCASE.COUNTRIES.COMOROS',

  content: {
    servicesSection: {
      title: 'SHOWCASE.COM.SERVICES.TITLE',
      subtitle: 'SHOWCASE.COM.SERVICES.SUBTITLE',
      services: [
        {
          icon: 'house',
          title: 'SHOWCASE.COM.SERVICES.HOTELS.TITLE',
          description: 'SHOWCASE.COM.SERVICES.HOTELS.DESCRIPTION',
          externalUrl: 'https://booking.com/country/km.html',
          category: ServiceCategory.ACCOMMODATION,
          image: 'assets/showcase/com-hotel-1.jpg'
        },
        {
          icon: 'umbrella-beach',
          title: 'SHOWCASE.COM.SERVICES.BEACHES.TITLE',
          description: 'SHOWCASE.COM.SERVICES.BEACHES.DESCRIPTION',
          externalUrl: 'https://www.tripadvisor.com/Attractions-g293779-Activities-c61-Comoros.html',
          category: ServiceCategory.ACTIVITIES,
          image: 'assets/showcase/com-beach-2.jpg'
        },
        {
          icon: 'mountain',
          title: 'SHOWCASE.COM.SERVICES.HIKING.TITLE',
          description: 'SHOWCASE.COM.SERVICES.HIKING.DESCRIPTION',
          externalUrl: 'https://www.getyourguide.com/comoros-l170/',
          category: ServiceCategory.ACTIVITIES,
          image: 'assets/showcase/com-hiking-1.jpg'
        },
        {
          icon: 'car',
          title: 'SHOWCASE.COM.SERVICES.TRANSPORT.TITLE',
          description: 'SHOWCASE.COM.SERVICES.TRANSPORT.DESCRIPTION',
          externalUrl: 'https://www.rentalcars.com/en/country/km/',
          category: ServiceCategory.TRANSPORT,
          image: 'assets/showcase/com-transport-1.jpg'
        },
        {
          icon: 'info-circle',
          title: 'SHOWCASE.COM.SERVICES.INFO.TITLE',
          description: 'SHOWCASE.COM.SERVICES.INFO.DESCRIPTION',
          externalUrl: 'https://www.lonelyplanet.com/comoros',
          category: ServiceCategory.SERVICES,
          image: 'assets/showcase/com-info-1.jpg'
        }
      ]
    }
  },

  ui: {
    showLanguageSwitcher: true,
    showServicesSection: false
  },

  showcase: {
    showPassport: true,
    showIdCard: true,
    showResidencePermit: true,
    showEvisa: false
  }
};
